import React from "react";
import BlueHeading from "../other/common/BlueHeading";
import Heading from "../common/ui/Heading";
import deepakImg from "../../assets/images/png/deepak-sharma-circle-img.png";
import societyMessageImg from "../../assets/images/webp/society-message-img.webp";
const GivingBack = () => {
  return (
    <>
      <div className="py-[140px] px-4 max-xl:py-[120px] max-lg:py-24 max-md:py-20 max-sm:py-10">
        <div className="max-w-[1027px] mx-auto">
          <div className="flex items-center justify-between max-xl:gap-6 max-lg:flex-wrap-reverse">
            <div className="max-w-[490px] max-lg:max-w-full">
              <BlueHeading lineClassOne="!hidden" text="Giving Back" />
              <Heading children="A Message – For Society" />
              <p className="text-[#010101] font-medium text-xl leading-[150%] pt-3">
                “ I am what I am because of society. It is my duty to give back
                to society.”
              </p>
              <div className="flex items-center gap-3 pt-3">
                <img
                  src={deepakImg}
                  alt="deepak-sharma"
                  className="w-full max-w-[43px]"
                />
                <p className="text-[#001A3D] font-semibold text-xs leading-[19.31px]">
                  – Shri Deepak Ji
                </p>
              </div>
            </div>
            <img
              src={societyMessageImg}
              alt="message"
              className="w-full max-w-[479px] pointer-events-none max-lg:max-w-full"
            />
          </div>
        </div>
      </div>
      <div className="pb-[140px] px-4 max-xl:pb-[120px] max-lg:pb-24 max-md:pb-20 max-sm:pb-10">
        <div className="max-w-[871px] mx-auto">
          <div className="flex items-center justify-center flex-col">
            <BlueHeading text="Join Us" />
            <Heading
              children="Want to Join the Mission?"
              className="text-center"
            />
            <p className="text-center text-[#5E5C5C] text-[26px] max-md:text-2xl max-sm:text-xl font-normal leading-[150%] pt-4">
              To be a part of Makeway India's social campaigns, contact us –
              because while one person starts, it takes a team to bring change.
            </p>
          </div>
        </div>
      </div>
      <div className="h-[190px]"></div>
    </>
  );
};

export default GivingBack;
